// Thin typed wrapper over @optimyl/telemetry. The shared package owns how every Optimyl web app reports to
// Application Insights; this file only adds the workbench's role name and its closed list of business events.

import { initAppInsights as init, setAuthenticatedUser, clearAuthenticatedUser, trackError, trackWarning, trackEvent as track } from "@optimyl/telemetry";

export { setAuthenticatedUser, clearAuthenticatedUser, trackError, trackWarning };

export function initAppInsights(connectionString?: string): void {
  init({ connectionString, roleName: "Optimyl.UwWorkbench.UI" });
}

export type BusinessEventName =
  | "GroupCreated"
  | "GroupCopied"
  | "GroupVersionRestored"
  | "MemberExcluded"
  | "RatingAdded"
  | "RatingOverridden"
  | "ChangeReasonRecorded"
  | "SendToSales"
  | "ExpectedDebitsTableActivated"
  | "DebitModificationSaved"
  | "MugsManualApplied";

export function trackEvent(name: BusinessEventName, properties?: Record<string, string>): void {
  track(name, properties);
}
